<template>
  <BasicTitle v-if="getTitle" :class="prefixCls" bold :helpMessage="helpMessage">
    {{ getTitle }}
  </BasicTitle>
</template>
<script lang="ts" setup>
  import { computed, PropType } from 'vue';
  import { isFunction } from '@mts-fe/utils';
  import { BasicTitle } from '@mts/components/Basic';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import { t } from '@mts/hooks/web/useI18n';

  defineOptions({ name: 'BasicTableTitle' });

  const props = defineProps({
    title: {
      type: [Function, String] as PropType<string | ((data) => string)>,
    },
    getSelectRows: {
      type: Function as PropType<() => any[]>,
    },
    helpMessage: {
      type: [String, Array] as PropType<string | string[]>,
    },
    count: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
  });

  const { prefixCls } = useDesign('basic-table-title');

  const getTitle = computed(() => {
    const { title, count, total, getSelectRows = () => [] } = props;
    var tit = '';

    if (isFunction(title)) {
      tit = title({ count, total, selectRows: getSelectRows() });
    } else {
      tit = title || '';
    }
    return t(tit);
  });
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-basic-table-title';

  .@{prefix-cls} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
